import { CustomStatusPanelProps } from "ag-grid-react";
import { useEffect, useState } from "react";

import formatGridRowCountFooter from "~/helpers/grid/formatGridRowCountFooter";

const GridRowCountStatusPanel = (props: CustomStatusPanelProps) => {
	const [shown, setShown] = useState(0);
	const [total, setTotal] = useState<number | undefined>(undefined);

	useEffect(() => {
		const update = () => {
			if (props.api.isDestroyed()) return;
			const displayed = props.api.getDisplayedRowCount();
			setShown(displayed);
			if (!props.api.isAnyFilterPresent()) setTotal(displayed);
		};
		update();
		props.api.addEventListener("modelUpdated", update);

		return () => {
			if (props.api.isDestroyed()) return;
			props.api.removeEventListener("modelUpdated", update);
		};
	}, [props.api]);

	return (
		<div style={{ padding: "5px" }}>
			<span>{formatGridRowCountFooter({ shown, total })}</span>
		</div>
	);
};

export default GridRowCountStatusPanel;
